import React from 'react';
import api from "./../../../../services/api";

//import da API
import { professional } from './../../../../services/api';
let apiProfessional = new professional();

var token = localStorage.getItem('user_token');

export default class PersonList extends React.Component {
  state = {
    nome: []
  }

  componentDidMount() {
    //api.get(`/user?_id=${this.props.user_id}`, {headers: {'x-access-token': token}})
    apiProfessional.getUser(this.props.user_id)
      .then(res => {
        const nome = res.data;
        this.setState({ nome });
      })
  }

  render() {
    return (
      <ul>
        {this.state.nome.map(person =>
          <span>{person.numericID}- {person.name} </span>)}
      </ul>
    )
  }
}